import { useCallback, useState } from "react";
export var useOnClearSearch = function (onClearSearch, onSearchCleared) {
    var _a = useState(), clearSearchId = _a[0], setClearSearchId = _a[1];
    var onResetSearch = useCallback(function (state) {
        setClearSearchId(Date.now());
        onSearchCleared === null || onSearchCleared === void 0 ? void 0 : onSearchCleared();
        return onClearSearch === null || onClearSearch === void 0 ? void 0 : onClearSearch(state);
    }, [onClearSearch, onSearchCleared]);
    return { clearSearchId: clearSearchId, onResetSearch: onResetSearch };
};
//# sourceMappingURL=use-on-clear-search.js.map